/**
 * MLB team primary colors keyed by the `teamCode` field in the GUMBO snapshot
 * (`gameData.teams.{away,home}.teamCode`). Approximate hex of the team's
 * primary brand color. Used to color the jersey-number rings on the
 * FieldDiamond and the score chips in the ribbon.
 */
export const TEAM_COLORS: Readonly<Record<string, { primary: string; secondary: string }>> = {
  ari: { primary: '#A71930', secondary: '#000000' },
  atl: { primary: '#CE1141', secondary: '#13274F' },
  bal: { primary: '#DF4601', secondary: '#000000' },
  bos: { primary: '#BD3039', secondary: '#0C2340' },
  chc: { primary: '#0E3386', secondary: '#CC3433' },
  cha: { primary: '#27251F', secondary: '#C4CED4' }, // CWS
  cin: { primary: '#C6011F', secondary: '#000000' },
  cle: { primary: '#E31937', secondary: '#0C2340' },
  col: { primary: '#33006F', secondary: '#C4CED4' },
  det: { primary: '#0C2340', secondary: '#FA4616' },
  hou: { primary: '#EB6E1F', secondary: '#002D62' },
  kca: { primary: '#004687', secondary: '#BD9B60' }, // KC
  ana: { primary: '#BA0021', secondary: '#003263' }, // LAA
  lan: { primary: '#005A9C', secondary: '#EF3E42' }, // LAD
  mia: { primary: '#00A3E0', secondary: '#EF3340' },
  mil: { primary: '#12284B', secondary: '#FFC52F' },
  min: { primary: '#002B5C', secondary: '#D31145' },
  nyn: { primary: '#002D72', secondary: '#FF5910' }, // NYM
  nya: { primary: '#003087', secondary: '#E4002C' }, // NYY
  oak: { primary: '#003831', secondary: '#EFB21E' },
  phi: { primary: '#E81828', secondary: '#002D72' },
  pit: { primary: '#FDB827', secondary: '#27251F' },
  sdn: { primary: '#2F241D', secondary: '#FFC425' }, // SD
  sfn: { primary: '#FD5A1E', secondary: '#27251F' }, // SF
  sea: { primary: '#0C2C56', secondary: '#005C5C' },
  sln: { primary: '#C41E3A', secondary: '#0C2340' }, // STL
  tba: { primary: '#092C5C', secondary: '#8FBCE6' }, // TB
  tex: { primary: '#003278', secondary: '#C0111F' },
  tor: { primary: '#134A8E', secondary: '#1D2D5C' },
  was: { primary: '#AB0003', secondary: '#14225A' },
};

export function teamColor(teamCode: string | undefined | null): { primary: string; secondary: string } {
  if (!teamCode) return { primary: '#666666', secondary: '#222222' };
  return TEAM_COLORS[teamCode.toLowerCase()] ?? { primary: '#666666', secondary: '#222222' };
}
